import {React,useState,useEffect }from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import avatar1 from "../../assets/images/users/avatar-1.jpg"
import profileImg from "../../assets/images/profile-img.png"

const WelcomeComp = () => {
  const [agent, setAgent] = useState('')
  const [agentCode, setAgentcode] = useState('')
  const [premium, setPremium] = useState(0)
  const [agentName, setAgentname] = useState('')
  const [approved, setApproved] = useState(0)
  const [credentials, setCredentials] = useState(null)
  const [isAuth, setIsauth] = useState(false)
  const company = 'Definite'

  useEffect(()=>{
  const getCredentials =async()=>{
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
    const data = await res.json();
    const {Username, Password} = data;
    const cred = btoa(`${Username}:${Password}`)
    setCredentials(btoa(`${Username}:${Password}`))
    setIsauth(true)


  }
  getCredentials()

  },[])

  useEffect(() => {

      const user = localStorage.getItem('definiteagent'); // Retrieve email
      if (user) {
          
          setAgent(user)
      } else {
  
      }
      }, []);
  
      useEffect(()=>{
          const getAgentcode =async()=>{
              const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
              });
              const data = await res.json();
              setAgentcode(data.OID)   
              if(data.Approved){
                setApproved(1)
              }
              else{
                setApproved(0)
              }
  
          }

          const getAgentname =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
               method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setAgentname(data.Dealer_name)
          }
          if(agent && isAuth){
              getAgentname()
              getAgentcode()
          }
      },[agent,isAuth])

      useEffect(()=>{
        const getData =async()=>{
          const res = await fetch(`https://digitalapi.definiteassurance.com/api/getRemittedpremium?agent=${agentCode}`,{
             method:"GET",
              headers:{
                'Authorization': `Basic ${credentials}`,
                'Content-Type': "application/json"
              }
          })
          const data = await res.json()
          
          if(data.RemittedPremium == null){
            setPremium(0)
          }
          else{
            setPremium(data.RemittedPremium)
          }
        }

        if(agentCode && isAuth){
          getData();
        }

      },[agentCode,isAuth])

      function formatter(amount) {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }



  return (
    <div>
      <Card className="overflow-hidden">
        <div className="bg-primary-subtle" id="loginTop">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 style={{color:"#fff"}}>Welcome Back !</h5>
                <p style={{color:"#fff"}}>Definite Assurance Agents Portal</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="4">
              <div className="avatar-md profile-user-wid mb-4">
                <img
                  src='/usericon.png'
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <h5 className="font-size-15 text-truncate">{agentName}</h5>
              <p className="text-muted mb-0 text-truncate">Agent</p>
              {approved == 1&&
              <p style={{color:'green'}}>APPROVED</p>
              }
               {approved == 0&&
              <>
              <p style={{color:'red'}}>PENDING APPROVAL</p>
            
              </>
              }
            </Col>

            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col xs="6">
                    <h5 className="font-size-15">KES. {formatter(parseInt(premium))}</h5>
                    <p className="text-muted mb-0">Remitted Premium</p>
                  </Col>
                  <Col xs="6">
                    <h5 className="font-size-15">KES. {formatter(0)}</h5>
                    <p className="text-muted mb-0">Received Commission</p>
                  </Col>
                </Row>
                <div className="mt-4">
                  <Link
                    to="/get-cover"
                    className="btn btn-success  btn-sm"
                  >
                    Book new cover <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
      {approved == 0 &&
      
        <Card>
        <CardBody>
            <p style={{color:'red',fontSize:18}}>Upload KYC's for approval</p>
            <p>Navigate to 'Documents' and Click 'Upload KYC' Button</p>
        </CardBody>
      </Card>
      }
      
    </div>
  )
}
export default WelcomeComp
